import React from "react";

import BaseAvatar from "./BaseAvatar";
import { getFullName } from "../../util";
import { StyledAvatarContainer } from "./styles";

const BaseAvatarUser = ({ user }) => {
  const fullName = getFullName(user.firstName, user.middleName, user.lastName);
  return (
    <StyledAvatarContainer>
      <BaseAvatar name={fullName} userId={user.id} />
      <div>{fullName}</div>
    </StyledAvatarContainer>
  );
};

export default BaseAvatarUser;
